<template>
  <div @click.self="$emit('close')"
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4 sm:p-0">
    <div
      class="bg-primary-bg dark:bg-primary-dark-bg p-6 sm:p-10 rounded-lg border border-light-border dark:border-dark-border w-full max-w-md sm:max-w-2xl max-h-[90vh] overflow-y-auto custom-scroll relative">
      <button @click="$emit('close')"
        class="absolute top-2 right-2 p-1 text-gray-400 hover:text-secondary-text dark:text-gray-300 dark:hover:text-white">
        <XMarkIcon class="w-6 h-6" />
      </button>

      <form @submit.prevent="$emit('submit')">
        <div v-for="(label, key) in fields" :key="key" class="mb-4">
          <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">{{ label }}</label>
          <input :type="key === 'dealer_tel' ? 'tel' : 'text'" :value="form[key]"
            @input="$emit('update:form', { ...form, [key]: $event.target.value })"
            class="w-full border rounded px-3 py-2 text-sm bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100 border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
        </div>

        <div class="mb-6">
          <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Bayi Durumu</label>
          <select :value="form.dealer_status"
            @change="$emit('update:form', { ...form, dealer_status: parseInt($event.target.value) })"
            class="w-full p-2 border rounded mb-4 bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100 border-gray-300 dark:border-gray-600">
            <option :value="1">Aktif</option>
            <option :value="0">Pasif</option>
          </select>
        </div>

        <div class="flex justify-end gap-3">
          <button type="submit"
            class="w-full bg-primary-button text-white py-2 px-4 rounded hover:bg-primary-button-hover transition">
            {{ loading ? 'Kaydediliyor...' : (mode === 'create' ? 'Kaydet' : 'Güncelle') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { XMarkIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'CompanyModal',
  components: { XMarkIcon },
  props: {
    form: Object,
    fields: Object,
    mode: String,
    loading: Boolean
  }
};
</script>
